<template>
<!-- 地图图层 -->
  <div id="MapViewer">
  </div>
</template>

<script>
import * as Three from "three"

export default {
  name: 'PLDigitalVillage',
  methods:
  {
    InitMapViewer: function () {
        plMap.initMap("MapViewer");
        plDataInterface.InitDataInterface(plMap.webGlobe.viewer);
        plMap.initViewLocation();
    }
  },
  mounted: function () {
    this.InitMapViewer();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
#MapViewer {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -99;
  min-height: 1024px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/PLDigitalVillage.vue